import { render } from "./SubResourceCenter.vue?vue&type=template&id=6d52b8ba&scoped=true"
import script from "./SubResourceCenter.vue?vue&type=script&lang=js"
export * from "./SubResourceCenter.vue?vue&type=script&lang=js"

import "./SubResourceCenter.vue?vue&type=style&index=0&id=6d52b8ba&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d52b8ba"]])

export default __exports__